import { useState } from "react";

import type {
  UserPrivateProfile,
  UserPublicProfile,
} from "@/pages/profile/api";
import { ProfileModelGames } from "@/pages/profile/ProfileModelGames";
import { ProfileTimeline } from "@/pages/profile/ProfileTimeline";
import { useI18n } from "@/shared/i18n/LanguageContext";

type ProfileActivityPanelProps = {
  profile: UserPublicProfile | UserPrivateProfile;
};

type ProfileActivityTab = "activity" | "games";

export function ProfileActivityPanel({ profile }: ProfileActivityPanelProps) {
  const { copy } = useI18n();
  const labels = copy.profile.activity;
  const [activeTab, setActiveTab] = useState<ProfileActivityTab>("activity");
  const gameCount = profile.activity_summary.games_played;

  return (
    <article className="profile-section profile-activity-section">
      <div className="profile-activity-tabs" role="tablist" aria-label={labels.viewsLabel}>
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === "activity"}
          data-active={activeTab === "activity"}
          onClick={() => setActiveTab("activity")}
        >
          {labels.activity}
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === "games"}
          data-active={activeTab === "games"}
          onClick={() => setActiveTab("games")}
        >
          {gameCount} {gameCount === 1 ? labels.game : labels.games}
        </button>
      </div>

      <div className="profile-activity-panel" role="tabpanel">
        {activeTab === "activity" ? (
          <ProfileTimeline username={profile.username} embedded />
        ) : (
          <ProfileModelGames username={profile.username} />
        )}
      </div>
    </article>
  );
}
